export class Option {
    id: Object;
    name: String;

    constructor(id: Object, name: String) {
        this.id = id;
        this.name = name;
    }
}